// src/actions/courses_actions.js
import axios from 'axios';
import * as APIUtil from '../util/course_api_util';

export const DELETE_COURSE = 'DELETE_COURSE';
export const RECEIVE_COURSES = 'RECEIVE_COURSES';
export const RECEIVE_COURSE = 'RECEIVE_COURSE';
export const ADD_COURSE = 'ADD_COURSE';
export const RECEIVE_COURSE_DETAIL = 'RECEIVE_COURSE_DETAIL';
export const ADD_USERS_TO_COURSE = 'ADD_USERS_TO_COURSE';

// =============
// ACTION CREATORS
// =============

export const receiveCourses = (courses) => ({
  type: RECEIVE_COURSES,
  courses,
});

export const receiveCourse = (course) => ({
  type: RECEIVE_COURSE,
  course,
});

export const addCourse = (course) => ({
  type: ADD_COURSE,
  course,
});

const addUsersToCourseAction = (course) => ({
  type: ADD_USERS_TO_COURSE,
  course,
});

// Used by the prep viewer (course + sections by key)
export const receiveCourseDetail = (course) => ({
  type: RECEIVE_COURSE_DETAIL,
  course,
});

// =============
// THUNKS
// =============

// All courses (list)
export const getCourses = () => async (dispatch) => {
  try {
    const res = await APIUtil.fetchCourses();
    dispatch(receiveCourses(res.data));
  } catch (err) {
    console.error('Error fetching courses:', err);
  }
};

// Single course by Mongo _id (admin / legacy use)
export const getCourse = (courseId) => async (dispatch) => {
  try {
    const res = await APIUtil.fetchCourse(courseId);
    dispatch(receiveCourse(res.data));
  } catch (err) {
    console.error('Error fetching course by id:', err);
  }
};

// 🔑 Single course by `key` (ombre_powder_brows / nanoblading_hairstrokes / lip_blush)
// This hits your `/api/courses/key/:key` route (WITHOUT sections)
export const fetchCourseByKey = (courseKey) => async (dispatch) => {
  try {
    const res = await APIUtil.fetchCourseByKey(courseKey);
    dispatch(receiveCourse(res.data));
  } catch (err) {
    console.error(`Error fetching course by key "${courseKey}":`, err);
  }
};

// Create course
export const createNewCourse = (courseData) => async (dispatch) => {
  try {
    const res = await APIUtil.createCourse(courseData);
    dispatch(addCourse(res.data));
  } catch (err) {
    console.error('Error creating course:', err);
  }
};

// Delete course (by _id)
export const deleteCourse = (courseId) => async (dispatch) => {
  console.log('deleteCourse called with ID:', courseId);
  try {
    await APIUtil.deleteCourse(courseId);
    dispatch({ type: DELETE_COURSE, payload: courseId });
  } catch (error) {
    console.error('Error deleting course:', error);
  }
};

// Add users to course (admin / assigning)
export const addUsersToCourse = (courseId, userIds) => async (dispatch) => {
  try {
    const response = await APIUtil.addUsersToCourse(courseId, userIds);
    dispatch(addUsersToCourseAction(response.data));
  } catch (error) {
    console.error('Error adding users to course:', error);
  }
};

// 🔍 FULL course detail (course + sections) by key
// Uses your route: GET /api/courses/key/:courseKey/full
export const fetchCourseDetail = (courseKey) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/courses/key/${courseKey}/full`);
    dispatch(receiveCourseDetail(res.data));
  } catch (err) {
    console.error('Error fetching course detail:', err);
  }
};
